export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10266.30921c6b.jpg";